// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2yqp0","fileBtn":"File_fileBtn__5FFLe","closeBtn":"File_closeBtn__1hIJo","fileSelected":"File_fileSelected__2IC-q","disabled":"File_disabled__1hUU3"};